import React from "react";
import { navigate } from "gatsby";
import {
  FaTimes,
  FaAngleRight,
  FaInstagramSquare,
  FaFacebookSquare,
} from "react-icons/fa";

import guerraLogo from "../assets/images/logo-blue.png";

export default function Sidebar({ sidebarManager }) {
  const { sidebar, closeSidebar } = sidebarManager;

  return (
    <>
      {sidebar ? (
        <div className="sidebar">
          <div
            className="sidebar-background"
            role="button"
            aria-label="Fechar sidebar"
            tabIndex="0"
            onClick={closeSidebar}
            onKeyDown={closeSidebar}
          />
          <section className="sidebar-section">
            <div className="container">
              <div className="row justify-content-between align-items-center mb-5">
                <div className="col-auto">
                  <h1 className="mb-0">Menu</h1>
                </div>
                <div className="col-auto">
                  <FaTimes
                    role="button"
                    className="sidebar-icon"
                    onClick={closeSidebar}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-2">
                  <button
                    className="btn btn-block"
                    onClick={() => navigate("/duvidas-frequentes")}
                  >
                    <h1 className="sidebar-text">
                      Dúvidas Frequentes{" "}
                      <FaAngleRight
                        role="button"
                        className="sidebar-icon"
                        onClick={closeSidebar}
                      />
                    </h1>
                  </button>
                </div>
                <div className="col-12 mb-2">
                  <button
                    className="btn btn-block"
                    onClick={() => navigate("/politica-privacidade")}
                  >
                    <h1 className="sidebar-text">
                      Política de Privacidade{" "}
                      <FaAngleRight
                        role="button"
                        className="sidebar-icon"
                        onClick={closeSidebar}
                      />
                    </h1>
                  </button>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row text-right">
                <div className="col-12 mb-3">
                  <FaInstagramSquare
                    role="button"
                    className="sidebar-social"
                    onClick={() =>
                      window.open("https://www.instagram.com/guerraconsorcios/")
                    }
                  />
                  <FaFacebookSquare
                    role="button"
                    className="sidebar-social ml-2"
                    onClick={() =>
                      window.open("https://www.facebook.com/guerraconsorcios/")
                    }
                  />
                </div>
                <div
                  className="col-12"
                  role="button"
                  aria-label="Fechar sidebar"
                  tabIndex="0"
                  onClick={() =>
                    window.open("https://www.guerraconsorcios.com.br/")
                  }
                  onKeyDown={() =>
                    window.open("https://www.guerraconsorcios.com.br/")
                  }
                >
                  <img
                    src={guerraLogo}
                    className="welcome-guerra-logo text-right"
                    alt="Logomarca da Guerra Consórcios"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : null}
    </>
  );
}
